import type { ReactNode } from "react";
import { twMerge } from "@/lib/twMerge";

const TONES = {
  neutral: "bg-sunken border-line-mid text-text",
  accent: "bg-accent-bg border-accent-line text-accent",
  warn: "bg-warn-bg border-warn-line text-warn",
  // Guild orange, tinted: a capability's input and output terms, so they read apart from
  // its kinds (accent) and its output types (neutral).
  brand: "bg-g-orange/10 border-g-orange/40 text-text",
};

/** A small pill for a status or category label (capability/standard/tool status, match
 * confidence, review verdict). `accent` reads as settled or positive, `warn` as something
 * to look at (deprecated, rejected, tier 0), `neutral` as neither, `brand` marks a
 * capability's input/output terms. */
export function Badge({
  tone = "neutral",
  children,
  className,
}: {
  tone?: keyof typeof TONES;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={twMerge(
        "inline-block rounded-full border px-2.5 py-0.5 text-xs whitespace-nowrap",
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
